export default __webpack_public_path__ + "static/media/long_play_button_down.5ec35e88.png";